import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProductsPage from "../pages/products/page";
import ProductDetailPage from "../pages/product/page";
import CheckoutPage from "../pages/checkout/page";
import ContactPage from "../pages/contact/page";
import ProfilePage from "../pages/profile/page";
import OrdersPage from "../pages/orders/page";
import FavoritesPage from "../pages/favorites/page";
import AddressesPage from "../pages/addresses/page";
import TemaPage from "../pages/tema/page";
import DynamicPage from "../pages/dynamic/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/urunler",
    element: <ProductsPage />,
  },
  {
    path: "/urun/:slug",
    element: <ProductDetailPage />,
  },
  {
    path: "/odeme",
    element: <CheckoutPage />,
  },
  {
    path: "/iletisim",
    element: <ContactPage />,
  },
  {
    path: "/profil",
    element: <ProfilePage />,
  },
  {
    path: "/siparislerim",
    element: <OrdersPage />,
  },
  {
    path: "/favorilerim",
    element: <FavoritesPage />,
  },
  {
    path: "/adreslerim",
    element: <AddressesPage />,
  },
  {
    path: "/tema",
    element: <TemaPage />,
  },
  {
    path: "/:slug",
    element: <DynamicPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
